import { fetchFromDashboardPublicApi } from './fetch';

export default async (id: string, email: string, externalAuthId: string): Promise<void> =>
    fetchFromDashboardPublicApi<void>(`/integrations?email=${email}&id=${id}&externalAuthId=${externalAuthId}`, {
        method: 'POST',
        headers: {},
    });
